module.exports = __webpack_public_path__ + "img/order-details.a3758a45.png";